import PropTypes from "prop-types";
import React from "react";

import { Button, Flex } from "antd";
import { CloseOutlined } from "@ant-design/icons";

export const Panel = ({ onClose, children }) => {
    return (
        <Flex className="toolbar-panel" vertical gap={12}>
            {onClose && (
                <Flex justify="flex-end" style={{ width: "100%" }}>
                    <Button
                        icon={<CloseOutlined />}
                        onClick={onClose}
                        type="text"
                    />
                </Flex>
            )}

            {children}
        </Flex>
    );
};

Panel.propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.any,
};
